export default __webpack_public_path__ + "static/media/info.aadd7d93.svg";